<script>
import Carriers from '@/views/Application/Manage/Accounts/Account/Configuration/Carriers'
export default {
  extends: Carriers,
  data () {
    return {
      breadcrumb: {
        name: 'Carriers',
        route: { name: 'customerservice-accounts-account-carriers', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
